export default __webpack_public_path__ + "static/media/element_4.be38bfd4.jpg";